import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { options: Object }

  connect() {
    if (this.hasOptionsValue) {
      this.dropdown = new bootstrap.Dropdown(this.element, this.optionsValue)
    } else {
      this.dropdown = new bootstrap.Dropdown(this.element)
    }
  }

  disconnect() {
    if (this.dropdown) {
      this.dropdown.hide()
      this.dropdown.dispose()
    }
  }
}
